// import React, { useEffect } from "react";
// import { useParams, Link } from "react-router-dom";
// import { blogData } from "../Blog/BlogData"; 
// import {
//   Calendar,
//   User,
//   Facebook,
//   Twitter,
//   Linkedin,
//   ArrowLeft,
//   Scale,
//   MessageSquare,
// } from "lucide-react";
// import Header from "../../layout/Header";
// import Footer from "../../layout/Footer";
// import { Helmet } from "react-helmet";

// // COLORS declared at the top as requested
// const COLORS = {
//   bgPrimary: "#0B1C2D",   // Deep Navy
//   bgSecondary: "#13293D", // Slightly Lighter Navy
//   gold: "#C6A75E",        // Premium Gold
//   textLight: "#EAEAEA",
// };

// const BlogDetails = () => {
//   const { blogId } = useParams();
//   const blog = blogData.find((b) => b.id === blogId);

//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, [blogId]);

//   if (!blog) {
//     return (
//       <div className="py-40 text-center font-serif" style={{ backgroundColor: COLORS.bgPrimary, color: COLORS.textLight }}>
//         <h2 className="text-3xl mb-4">Article Not Found</h2>
//         <Link to="/blogs" style={{ color: COLORS.gold }} className="underline">
//           Back to Insights
//         </Link>
//       </div>
//     );
//   }

//   return (
//     <>
//       <Helmet>
//         <title>{blog.title} | Rai & Associates Advocates & Solicitors</title>
//         <meta name="description" content={blog.excerpt} />
//         <meta name="author" content={blog.author} />
//         <meta property="og:title" content={blog.title} />
//         <meta property="og:image" content={blog.image} />
//       </Helmet>
      
//       <Header />

//       <div className="pt-32 pb-20 overflow-hidden min-h-screen" style={{ backgroundColor: COLORS.bgPrimary }}>
//         <div className="max-w-7xl mx-auto px-6">
          
//           {/* Back Navigation */}
//           <Link
//             to="/blogs"
//             className="group inline-flex items-center gap-2 mb-10 font-sans uppercase text-[10px] font-bold tracking-[3px] transition-all"
//             style={{ color: COLORS.gold }}
//           >
//             <ArrowLeft size={16} className="group-hover:-translate-x-2 transition-transform" />
//             Back to Legal Insights
//           </Link>

//           <div className="grid grid-cols-1 lg:grid-cols-12 gap-16">
//             {/* LEFT COLUMN: Main Article */}
//             <div className="lg:col-span-8">
//               <header className="mb-12">
//                 <div className="flex items-center gap-3 mb-6">
//                   <span 
//                     className="px-4 py-1.5 text-[10px] font-bold uppercase tracking-[3px]"
//                     style={{ backgroundColor: COLORS.gold, color: COLORS.bgPrimary }}
//                   >
//                     {blog.category}
//                   </span>
//                   <div className="h-[1px] w-12 opacity-30" style={{ backgroundColor: COLORS.gold }}></div>
//                 </div>

//                 <h1 className="text-white text-4xl md:text-6xl font-bold leading-[1.1] mb-10">
//                   {blog.title}
//                 </h1>

//                 <div className="flex flex-wrap items-center gap-8 text-gray-400 text-[11px] border-y border-white/10 py-8 font-sans uppercase tracking-[2px]">
//                   <span className="flex items-center gap-2">
//                     <Calendar size={14} style={{ color: COLORS.gold }} /> {blog.date}
//                   </span>
//                   <span className="flex items-center gap-2 text-white font-bold">
//                     <User size={14} style={{ color: COLORS.gold }} /> By {blog.author}
//                   </span>
//                 </div>
//               </header>

//               {/* Featured Image with Premium Border Detail */}
//               <div className="relative mb-16">
//                 <div 
//                     className="absolute inset-0 border-[1px] translate-x-4 translate-y-4 -z-10 opacity-20"
//                     style={{ borderColor: COLORS.gold }}
//                 ></div>
//                 <img
//                   src={blog.image}
//                   alt={blog.title}
//                   className="w-full h-[550px] object-cover rounded-xl shadow-2xl"
//                 />
//                 <div className="absolute -bottom-10 -right-10 hidden md:block opacity-5">
//                   <Scale size={200} color={COLORS.gold} />
//                 </div>
//               </div>

//               {/* Article Content */}
//               <div className="legal-journal-content-container">
//                 <div
//                   className="article-body-text text-gray-300"
//                   dangerouslySetInnerHTML={{ __html: blog.content }}
//                 />
//               </div>

//               {/* Social Share */}
//               <div className="mt-24 pt-10 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-8">
//                 <div>
//                   <p className="text-white text-xl font-bold mb-2">Rai & Associates Advocates</p>
//                   <p className="text-[10px] text-gray-500 uppercase tracking-[2px]">Ensuring Justice Through Expertise</p>
//                 </div>
//                 <div className="flex gap-6">
//                   {[Facebook, Twitter, Linkedin].map((Icon, idx) => (
//                       <Icon key={idx} size={20} className="text-gray-400 hover:text-white transition-all cursor-pointer" />
//                   ))}
//                 </div>
//               </div>
//             </div>

//             {/* RIGHT COLUMN: Sidebar */}
//             <div className="lg:col-span-4">
//               <div className="sticky top-32 space-y-8">
                
//                 {/* Consultation Card */}
//                 <div 
//                     className="p-10 text-white rounded-2xl shadow-2xl overflow-hidden relative border border-white/5"
//                     style={{ backgroundColor: COLORS.bgSecondary }}
//                 >
//                   <div 
//                     className="absolute top-0 right-0 w-32 h-32 rounded-full -mr-16 -mt-16 opacity-10"
//                     style={{ backgroundColor: COLORS.gold }}
//                   ></div>

//                   <h3 className="text-2xl font-bold mb-6 border-b pb-4 relative z-10" style={{ color: COLORS.gold, borderColor: "rgba(206, 167, 94, 0.2)" }}>
//                     Legal Assistance
//                   </h3>
//                   <p className="text-sm text-gray-400 font-sans mb-10 leading-[1.8] italic relative z-10">
//                     "The law is a profession of words; we ensure your words carry the weight of justice."
//                   </p>

//                   <Link to="/contact-us" className="relative z-10 block">
//                     <button 
//                         className="w-full bg-transparent border-2 font-bold py-5 uppercase text-[10px] tracking-[4px] transition-all duration-500 rounded-xl hover:text-white"
//                         style={{ borderColor: COLORS.gold, color:"#fff" }}
//                         onMouseEnter={(e) => e.target.style.backgroundColor = COLORS.gold}
//                         onMouseLeave={(e) => e.target.style.backgroundColor = "transparent"}
//                     >
//                       Request Consultation
//                     </button>
//                   </Link>

//                   <div className="mt-12 pt-8 border-t border-white/5 flex flex-col gap-4 text-[11px] font-sans tracking-[1px] text-gray-500">
//                     <p className="flex items-center gap-2"><MessageSquare size={14} style={{ color: COLORS.gold }} /> Confidential Advisory</p>
//                     <p>📍 Saket Court, New Delhi</p>
//                   </div>
//                 </div>

//                 {/* Topics Cloud */}
//                 <div className="p-8 rounded-2xl border border-white/5" style={{ backgroundColor: COLORS.bgSecondary }}>
//                   <h4 className="font-bold text-white mb-6 text-xs uppercase tracking-widest">
//                     Legal Topics
//                   </h4>
//                   <div className="flex flex-wrap gap-2">
//                     {["Family Law", "Criminal Law", "Bail", "Divorce", "RERA"].map((tag) => (
//                       <span
//                         key={tag}
//                         className="text-[9px] border px-4 py-2 uppercase text-gray-400 hover:text-white cursor-pointer transition-all rounded-full"
//                         style={{ borderColor: "rgba(255,255,255,0.1)" }}
//                       >
//                         {tag}
//                       </span>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Dynamic Journal Styling */}
//         <style dangerouslySetInnerHTML={{ __html: `
//             .article-body-text {
//               font-family: 'Inter', sans-serif;
//               line-height: 2;
//               font-size: 1.125rem;
//             }
//             .article-body-text p {
//               margin-bottom: 2rem;
//               opacity: 0.85;
//             }
//             .article-body-text h2 {
//               font-size: 2.5rem;
//               color: white;
//               font-weight: 700;
//               margin: 4rem 0 1.5rem;
//               border-left: 4px solid ${COLORS.gold};
//               padding-left: 20px;
//             }
//             .article-body-text strong {
//               color: ${COLORS.gold};
//               font-weight: 700;
//             }
//             .article-body-text blockquote {
//               margin: 3rem 0;
//               padding: 2.5rem;
//               background: ${COLORS.bgSecondary};
//               border-radius: 1rem;
//               border-left: 4px solid ${COLORS.gold};
//               font-style: italic;
//               font-size: 1.4rem;
//               color: white;
//             }
//             .article-body-text ul {
//               margin-bottom: 2rem;
//             }
//             .article-body-text li {
//               position: relative;
//               padding-left: 1.5rem;
//               margin-bottom: 1rem;
//               list-style: none;
//             }
//             .article-body-text li::before {
//               content: "";
//               position: absolute;
//               left: 0;
//               top: 12px;
//               width: 8px;
//               height: 2px;
//               background: ${COLORS.gold};
//             }
//         `}} />
//       </div>

//       <Footer />
//     </>
//   );
// };

// export default BlogDetails;










import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { blogData } from "../Blog/BlogData";
import {
  Calendar,
  User,
  Facebook,
  Twitter,
  Linkedin,
  ArrowLeft,
  Scale,
  MessageSquare,
  Instagram,
  MapPin,
  Phone,
  Clock,
} from "lucide-react";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import { Helmet } from "react-helmet";

// ─── Classical Color System ────────────────────────────────────────────────
const COLORS = {
  white: "#FFFFFF",
  offWhite: "#FAF5F6",
  warmGray: "#F4EFEF",
  burgundy: "#6B1E2E",
  burgundyLight: "#8B3244",
  burgundyPale: "#F0E4E6",
  black: "#1A1A1A",
  charcoal: "#3A3A3A",
  muted: "#888888",
  border: "#E0D5D5",
  borderLight: "#F0E8E8",
};


// ─── Injected global styles ────────────────────────────────────────────────
const globalStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,700;1,400&family=Inter:wght@300;400;500;600&display=swap');

  .blog-detail-page {
    background: ${COLORS.white};
    font-family: 'Inter', sans-serif;
    color: ${COLORS.black};
  }

  /* ── Breadcrumb band ── */
  .bdb-band {
    background: ${COLORS.burgundy};
    padding: 6px 0;
  }
  .bdb-band-inner {
    max-width: 1100px;
    margin: 0 auto;
    padding: 0 24px;
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .bdb-back-link {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 10px;
    letter-spacing: 2.5px;
    text-transform: uppercase;
    color: #f0d9de;
    text-decoration: none;
    font-weight: 600;
    transition: color 0.2s;
  }
  .bdb-back-link:hover { color: #ffffff; }
  .bdb-sep { color: rgba(255,255,255,0.3); font-size: 13px; }
  .bdb-crumb { font-size: 10px; letter-spacing: 2px; text-transform: uppercase; color: rgba(255,255,255,0.45); }

  /* ── Main layout ── */
  .bdb-outer {
    max-width: 1100px;
    margin: 0 auto;
    padding: 48px 24px 80px;
  }
  .bdb-grid {
    display: grid;
    grid-template-columns: 1fr 300px;
    gap: 56px;
    align-items: start;
  }
  @media (max-width: 900px) {
    .bdb-grid { grid-template-columns: 1fr; gap: 40px; }
  }

  /* ── Article header ── */
  .bdb-cat-pill {
    display: inline-block;
    background: ${COLORS.burgundy};
    color: #ffffff;
    font-size: 9px;
    letter-spacing: 3px;
    text-transform: uppercase;
    padding: 5px 16px;
    font-weight: 600;
    margin-bottom: 20px;
  }
  .bdb-title {
    font-family: 'Playfair Display', serif;
    font-size: clamp(32px, 5vw, 52px);
    font-weight: 700;
    color: ${COLORS.black};
    line-height: 1.12;
    margin-bottom: 24px;
  }
  .bdb-meta-strip {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 24px;
    padding: 16px 0;
    border-top: 1px solid ${COLORS.border};
    border-bottom: 1px solid ${COLORS.border};
    margin-bottom: 36px;
  }
  .bdb-meta-item {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 10px;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    color: ${COLORS.muted};
  }
  .bdb-meta-item strong {
    color: ${COLORS.black};
    font-weight: 600;
  }

  /* ── Featured image ── */
  .bdb-img-wrap {
    position: relative;
    margin-bottom: 44px;
    z-index: 1;
  }
  .bdb-img-border-deco {
    position: absolute;
    top: 10px;
    left: 10px;
    right: -10px;
    bottom: -10px;
    border: 1px solid ${COLORS.burgundy};
    opacity: 0.22;
    z-index: -1;
  }
  .bdb-img {
    width: 100%;
    height: 460px;
    object-fit: cover;
    display: block;
    border: 1px solid ${COLORS.border};
    position: relative;
    z-index: 1;
  }
  .bdb-img-label {
    position: absolute;
    bottom: 0;
    left: 0;
    background: ${COLORS.burgundy};
    color: #ffffff;
    font-size: 9px;
    letter-spacing: 2px;
    text-transform: uppercase;
    padding: 7px 16px;
    font-weight: 600;
    z-index: 2;
  }
  .bdb-scale-deco {
    position: absolute;
    bottom: -32px;
    right: -32px;
    opacity: 0.04;
    z-index: 0;
    pointer-events: none;
  }

  /* ── Article body ── */
  .bdb-article-body {
    font-family: 'Inter', sans-serif;
    font-size: 16px;
    line-height: 1.95;
    color: ${COLORS.charcoal};
  }
  .bdb-article-body p {
    margin-bottom: 1.5rem;
    opacity: 0.9;
  }
  .bdb-article-body h2 {
    font-family: 'Playfair Display', serif;
    font-size: 24px;
    color: ${COLORS.black};
    font-weight: 700;
    margin: 3rem 0 1.2rem;
    padding-left: 16px;
    border-left: 3px solid ${COLORS.burgundy};
    border-radius: 0;
    line-height: 1.3;
  }
  .bdb-article-body strong {
    color: ${COLORS.burgundy};
    font-weight: 600;
  }
  .bdb-article-body blockquote {
    background: ${COLORS.offWhite};
    border-left: 3px solid ${COLORS.burgundy};
    border-radius: 0;
    padding: 24px 28px;
    margin: 2.5rem 0;
    font-style: italic;
    font-family: 'Playfair Display', serif;
    font-size: 20px;
    color: ${COLORS.burgundy};
    line-height: 1.6;
  }
  .bdb-article-body ul {
    margin-bottom: 1.5rem;
    padding-left: 0;
    list-style: none;
  }
  .bdb-article-body li {
    position: relative;
    padding-left: 20px;
    margin-bottom: 10px;
    color: ${COLORS.charcoal};
  }
  .bdb-article-body li::before {
    content: '';
    position: absolute;
    left: 0;
    top: 13px;
    width: 8px;
    height: 1.5px;
    background: ${COLORS.burgundy};
  }
  .bdb-article-body a {
    color: ${COLORS.burgundy};
    text-decoration: underline;
    text-underline-offset: 3px;
  }

  /* ── Social strip ── */
  .bdb-social-strip {
    margin-top: 48px;
    padding-top: 24px;
    border-top: 1px solid ${COLORS.border};
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 16px;
  }
  .bdb-brand-name {
    font-family: 'Playfair Display', serif;
    font-size: 16px;
    color: ${COLORS.black};
    font-weight: 700;
    margin-bottom: 3px;
  }
  .bdb-brand-tagline {
    font-size: 9px;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: ${COLORS.muted};
  }
  .bdb-social-icons { display: flex; gap: 10px; }
  .bdb-soc-btn {
    width: 34px;
    height: 34px;
    border: 1px solid ${COLORS.border};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: ${COLORS.muted};
    transition: all 0.2s;
    background: transparent;
  }
  .bdb-soc-btn:hover {
    border-color: ${COLORS.burgundy};
    color: ${COLORS.burgundy};
  }

  /* ── Sidebar ── */
  .bdb-sidebar { display: flex; flex-direction: column; gap: 24px; }
  .bdb-side-card {
    border: 1px solid ${COLORS.border};
    padding: 26px;
    background: ${COLORS.white};
  }
  .bdb-side-title {
    font-family: 'Playfair Display', serif;
    font-size: 17px;
    color: ${COLORS.burgundy};
    font-weight: 700;
    padding-bottom: 14px;
    border-bottom: 1px solid ${COLORS.borderLight};
    margin-bottom: 4px;
  }
  .bdb-ornament {
    text-align: center;
    color: ${COLORS.burgundy};
    font-size: 14px;
    opacity: 0.3;
    letter-spacing: 6px;
    margin: 10px 0 18px;
  }
  .bdb-consult-quote {
    font-family: 'Playfair Display', serif;
    font-style: italic;
    font-size: 13px;
    color: ${COLORS.muted};
    line-height: 1.75;
    margin-bottom: 22px;
  }
  .bdb-cta-btn {
    display: block;
    width: 100%;
    padding: 14px;
    text-align: center;
    font-size: 9px;
    letter-spacing: 3.5px;
    text-transform: uppercase;
    font-weight: 700;
    border: 1.5px solid ${COLORS.burgundy};
    color: ${COLORS.burgundy};
    background: transparent;
    cursor: pointer;
    transition: all 0.25s;
    margin-bottom: 22px;
    text-decoration: none;
  }
  .bdb-cta-btn:hover {
    background: ${COLORS.burgundy};
    color: #ffffff;
  }
  .bdb-consult-meta {
    font-size: 11px;
    color: ${COLORS.muted};
    letter-spacing: 0.3px;
    border-top: 1px solid ${COLORS.borderLight};
    padding-top: 16px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .bdb-consult-meta-item {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  /* Topics */
  .bdb-tags-wrap { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 6px; }
  .bdb-tag {
    font-size: 9px;
    letter-spacing: 2px;
    text-transform: uppercase;
    padding: 6px 13px;
    border: 1px solid ${COLORS.border};
    color: ${COLORS.muted};
    cursor: pointer;
    transition: all 0.2s;
    background: transparent;
  }
  .bdb-tag:hover {
    border-color: ${COLORS.burgundy};
    color: ${COLORS.burgundy};
  }

  /* Recent articles */
  .bdb-recent-item {
    display: flex;
    gap: 14px;
    align-items: flex-start;
    padding: 14px 0;
    border-bottom: 1px solid ${COLORS.borderLight};
  }
  .bdb-recent-item:last-child { border-bottom: none; padding-bottom: 0; }
  .bdb-recent-thumb {
    width: 52px;
    height: 52px;
    background: ${COLORS.burgundyPale};
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .bdb-recent-label {
    font-size: 9px;
    color: ${COLORS.burgundy};
    letter-spacing: 2px;
    text-transform: uppercase;
    font-weight: 600;
    margin-bottom: 5px;
  }
  .bdb-recent-ttl {
    font-family: 'Playfair Display', serif;
    font-size: 13px;
    color: ${COLORS.black};
    line-height: 1.45;
  }

  /* Not-found */
  .bdb-not-found {
    min-height: 60vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-family: 'Playfair Display', serif;
    background: ${COLORS.white};
  }
  .bdb-not-found h2 {
    font-size: 32px;
    color: ${COLORS.black};
    margin-bottom: 16px;
  }
`;

// ─── Component ─────────────────────────────────────────────────────────────
const BlogDetails = () => {
  const { blogId } = useParams();
  const blog = blogData.find((b) => b.id === blogId);

  const socialLinks = [
  { Icon: Facebook, url: "https://www.facebook.com/people/Rai-Associates/61570798588995/" },
  { Icon: Instagram, url: "https://www.instagram.com/raiandassociates_/" },
];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [blogId]);

  if (!blog) {
    return (
      <>
        <style dangerouslySetInnerHTML={{ __html: globalStyles }} />
        <Header />
        <div className="bdb-not-found">
          <h2>Article Not Found</h2>
          <Link to="/blogs" style={{ color: COLORS.burgundy, textDecoration: "underline", fontSize: 14 }}>
            ← Back to Insights
          </Link>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Helmet>
        <title>{blog.title} | Rai & Associates Advocates & Solicitors</title>
        <meta name="description" content={blog.excerpt} />
        <meta name="author" content={blog.author} />
        <meta property="og:title" content={blog.title} />
        <meta property="og:image" content={blog.image} />
      </Helmet>

      <style dangerouslySetInnerHTML={{ __html: globalStyles }} />

      <Header />

      <div className="blog-detail-page">

        {/* Burgundy breadcrumb band */}
        <div className="bdb-band">
          <div className="bdb-band-inner">
            <Link to="/blogs" className="bdb-back-link">
              <ArrowLeft size={13} />
              Back to Legal Insights
            </Link>
            <span className="bdb-sep">›</span>
            <span className="bdb-crumb">{blog.category}</span>
          </div>
        </div>

        <div className="bdb-outer">
          <div className="bdb-grid">

            {/* ── LEFT: Article ── */}
            <article>
              <header>
                <div className="bdb-cat-pill">{blog.category}</div>
                <h1 className="bdb-title">{blog.title}</h1>
                <div className="bdb-meta-strip">
                  <div className="bdb-meta-item">
                    <Calendar size={13} color={COLORS.burgundy} />
                    {blog.date}
                  </div>
                  <div className="bdb-meta-item">
                    <User size={13} color={COLORS.burgundy} />
                    By <strong>{blog.author}</strong>
                  </div>
                  <div className="bdb-meta-item">
                    <Clock size={13} color={COLORS.burgundy} />
                    8 min read
                  </div>
                </div>
              </header>

              {/* Featured image */}
              <div className="bdb-img-wrap">
                <div className="bdb-img-border-deco" />
                <img
                  src={blog.image}
                  alt={blog.title}
                  className="bdb-img"
                />
                <div className="bdb-img-label">Featured Article</div>
                <div className="bdb-scale-deco">
                  <Scale size={180} color={COLORS.burgundy} />
                </div>
              </div>

              {/* Body */}
              <div
                className="bdb-article-body"
                dangerouslySetInnerHTML={{ __html: blog.content }}
              />

              {/* Social share */}
              <div className="bdb-social-strip">
                <div>
                  <div className="bdb-brand-name">Rai & Associates Advocates</div>
                  <div className="bdb-brand-tagline">Ensuring Justice Through Expertise</div>
                </div>
                <div className="bdb-social-icons">
  {socialLinks.map(({ Icon, url }, idx) => (
    <a
      key={idx}
      href={url}
      className="bdb-soc-btn"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Share"
    >
      <Icon size={15} />
    </a>
  ))}
</div>
              </div>
            </article>

            {/* ── RIGHT: Sidebar ── */}
            <aside className="bdb-sidebar">

              {/* Consultation card */}
              <div className="bdb-side-card">
                <div className="bdb-side-title">Legal Assistance</div>
                <div className="bdb-ornament">— ✦ —</div>
                <p className="bdb-consult-quote">
                  "The law is a profession of words; we ensure your words carry the weight of justice."
                </p>
                <Link to="/contact-us" className="bdb-cta-btn">
                  Request Consultation
                </Link>
                <div className="bdb-consult-meta">
                  <div className="bdb-consult-meta-item">
                    <MessageSquare size={13} color={COLORS.burgundy} />
                    Confidential Advisory
                  </div>
                  <div className="bdb-consult-meta-item">
                    <MapPin size={13} color={COLORS.burgundy} />
                    Saket Court, New Delhi
                  </div>
                  <div className="bdb-consult-meta-item">
                    <Phone size={13} color={COLORS.burgundy} />
                    Available Mon – Sat
                  </div>
                </div>
              </div>

              {/* Recent articles */}
              <div className="bdb-side-card">
                <div className="bdb-side-title">Recent Insights</div>
                <div className="bdb-ornament">—</div>
                {blogData
                  .filter((b) => b.id !== blogId)
                  .slice(0, 3)
                  .map((recent) => (
                    <Link
                      key={recent.id}
                      to={`/blogs/${recent.id}`}
                      style={{ textDecoration: "none" }}
                    >
                      <div className="bdb-recent-item">
                        <div className="bdb-recent-thumb">
                          <img
                            src={recent.image}
                            alt={recent.title}
                            style={{ width: "100%", height: "100%", objectFit: "cover" }}
                            onError={(e) => {
                              e.target.style.display = "none";
                              e.target.parentNode.innerHTML =
                                `<span style="font-size:22px;color:${COLORS.burgundy};opacity:0.5">⚖</span>`;
                            }}
                          />
                        </div>
                        <div>
                          <div className="bdb-recent-label">{recent.category}</div>
                          <div className="bdb-recent-ttl">{recent.title}</div>
                        </div>
                      </div>
                    </Link>
                  ))}
              </div>

              {/* Topics cloud */}
              <div className="bdb-side-card">
                <div className="bdb-side-title">Legal Topics</div>
                <div className="bdb-ornament">—</div>
                <div className="bdb-tags-wrap">
                  {["Family Law", "Criminal Law", "Bail", "Divorce", "RERA", "Property", "Custody"].map(
                    (tag) => (
                      <span key={tag} className="bdb-tag">{tag}</span>
                    )
                  )}
                </div>
              </div>

            </aside>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default BlogDetails;